
import { ColchesterRecordSubType, ColchesterRecordType } from "./ColchesterRecordTypes";
import { IRecordTypeFeatureInfoClick, RecordTypeResource, IRecordTypeHeading, IMappingTextPack } from "esdm-map";
import { ILayerGroup } from "esdm-map/dist/layers/groups/ILayerGroup";

let headingConfiguration = (): Array<IRecordTypeHeading> => {
    let items = new Array<IRecordTypeHeading>();

    items.push({
        recordTypeCode: ColchesterRecordType.Monument,
        recordSubTypeCode: null,
        heading: "Monument(s)"
    });

    items.push({
        recordTypeCode: ColchesterRecordType.Event,
        recordSubTypeCode: null,
        heading: "Event(s)"
    });

    items.push({
        recordTypeCode: ColchesterRecordType.Designation,
        recordSubTypeCode: null,
        heading: "Designation(s)"
    });

    items.push({
        recordTypeCode: ColchesterRecordType.Designation,
        recordSubTypeCode: ColchesterRecordSubType.ConservationArea,
        heading: "Conservation Area(s)"
    });

    items.push({
        recordTypeCode: ColchesterRecordType.Designation,
        recordSubTypeCode: ColchesterRecordSubType.ListedBuilding,
        heading: "Listed Building(s)"
    });

    items.push({
        recordTypeCode: ColchesterRecordType.Designation,
        recordSubTypeCode: ColchesterRecordSubType.RegisteredParksAndGardens,
        heading: "Registered Park / Garden"
    });

    items.push({
        recordTypeCode: ColchesterRecordType.Designation,
        recordSubTypeCode: ColchesterRecordSubType.ScheduledMonument,
        heading: "Scheduled Monument(s)"
    });  

    items.push({
        recordTypeCode: ColchesterRecordType.Designation,
        recordSubTypeCode: ColchesterRecordSubType.LocalList,
        heading: "Local List"
    });  

    return items;
}

export class HbsmrRecordTypeResource extends RecordTypeResource {

    public constructor(
        private _mappingTextPack: IMappingTextPack,
    ) {
        super(headingConfiguration());
    }
    
    public groupByRecordSubTypeCode(recordTypeCode: string): boolean 
    {
        return (recordTypeCode.toLowerCase() === ColchesterRecordType.Designation);        
    }      

    public mapToIRecordTypeInfoClick(featureProperties: any, layerGroup: ILayerGroup): IRecordTypeFeatureInfoClick 
    {
        return {
            id: "",
            uid: featureProperties.uid,
            ref: featureProperties.ref,
            name: featureProperties.name,
            recordType: featureProperties.rectype,
            recordSubType: featureProperties.recsubtype,
            recordSubTypeCode: featureProperties.recsubtypecode,
            data: featureProperties,
            heading: this.getHeading(featureProperties.rectype, featureProperties.recsubtypecode),
            layerGroup: layerGroup
        }
    }

    public getInfoClickHtmlTemplate(recordTypeInfoClick: IRecordTypeFeatureInfoClick): string 
    {
        let html: string = "";

        //add controller (or any arbitrary data) to the data object
        switch (recordTypeInfoClick.recordType.toLowerCase()) {
            case "mon":                
                recordTypeInfoClick.data.controller = "Monument";               
                break;
            case "event":
                recordTypeInfoClick.data.controller = "Event";               
                break;
            case "desig":
                recordTypeInfoClick.data.controller = "Designation";               
                break;  
        }

        html = `<div class='[css]'>
                  <a href='/[controller]/[uid]'>[uid] - [name]</a>
               </div>`;

        return html;
    }

    
}